import common from '@/stores/common';
import api from '@/stores/api';

export default {
	api, common
};
